import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import { BRAND } from '../constants/brand';

const Hero = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[92vh] flex items-center pt-24 pb-16 overflow-hidden bg-surface">
      <div className="absolute inset-0 bg-mesh" />
      <div className="absolute inset-0 bg-gradient-to-b from-white via-surface/80 to-surface pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold uppercase tracking-widest text-brand-violet mb-6">
            <span className="h-px w-8 bg-gradient-brand" />
            {BRAND.tagline}
          </p>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 leading-[1.1] mb-6">
            Technology that{' '}
            <span className="text-gradient">scales</span>
            <br />
            with your ambitions
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed mb-10 max-w-xl">
            From cloud and security to managed operations and modernization—we design pragmatic IT
            roadmaps and deliver measurable results for teams that cannot afford downtime.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              type="button"
              onClick={() => scrollTo('contact')}
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full font-semibold bg-gradient-brand text-white shadow-brand hover:opacity-95 transition-opacity"
            >
              Talk to us
              <FiArrowRight />
            </button>
            <button
              type="button"
              onClick={() => scrollTo('services')}
              className="inline-flex items-center justify-center px-8 py-3.5 rounded-full font-semibold border border-slate-200 bg-white text-slate-800 shadow-sm hover:border-slate-300 hover:bg-slate-50 transition-colors"
            >
              View capabilities
            </button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6"
        >
          {[
            { k: 'Uptime mindset', v: 'Operational excellence' },
            { k: 'Security-first', v: 'By design, not bolt-on' },
            { k: 'Business aligned', v: 'Clear outcomes & KPIs' },
            { k: 'Partnership', v: 'Long-term, not one-off' },
          ].map((item) => (
            <div
              key={item.k}
              className="rounded-2xl border border-slate-200 bg-white shadow-card p-4 md:p-5"
            >
              <p className="text-xs uppercase tracking-wider text-slate-500 mb-1">{item.k}</p>
              <p className="text-sm font-medium text-slate-800">{item.v}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
